module.exports = __webpack_public_path__ + "static/media/Dot.7f736a51.png";